// extracted by mini-css-extract-plugin
module.exports = {"buttonWrap":"solvency-check-modal_buttonWrap__vBOvI","content":"solvency-check-modal_content__B92Sy"};